export default "__VITE_ASSET__9126da3f__"